import React from 'react';
import Grid from '@mui/material/Grid';
import PropsType from 'prop-types';
import CAppComponentCard from 'pages/clients/UploadToClient/CAppComponentCard';
import AppComponentHeader from '@crema/core/AppComponentHeader';
import AppGridContainer from '@crema/core/AppGridContainer';
import BasicDropZone from './BasicDropZone';
import MatrixForBDAPI from './components/MatrixForBDAPI';
import {Typography, Alert, AlertTitle} from '@mui/material';

const AddDataUI = ({
  fileName,
  isClicked,
  setUploadedFiles,
  functionToRun,
  domainSelected,
  handleDomainChange,
  sendDataLoading,
  messages,
  uploadedFiles,
  fileSelected,
  affiliateId,
  dominId,
  onDropDownChange,
  onDropDownSearch,
  allStatusCountDB,
  doneStatusCountDB,
  errorStatusCountDB,
  errorDataDB,
  allStatusCountAPI,
  doneStatusCountAPI,
  errorStatusCountAPI,
  errorDataAPI,
  // Add validation props
  validationError,
  isFileValid,
  // Add upload completion props
  isUploadCompleted,
  hasSuccessfulData,
}) => {
  console.log('🎨 AddDataUI rendered with validation props:', {
    validationError,
    isFileValid,
  });
  return (
    <>
      <AppComponentHeader
        title='Upload Data To Client'
        description="Upload new data To Clinet And To Your Database by drag'n'drop files."
      />

      <AppGridContainer>
        <Grid item xs={12}>
          <CAppComponentCard
            title={''}
            domainSelected={domainSelected}
            handleDomainChange={handleDomainChange}
            fileSelected={fileSelected}
            sendDataLoading={sendDataLoading}
            functionToRun={functionToRun}
            affiliateId={affiliateId}
            dominId={dominId}
            onDropDownChange={onDropDownChange}
            onDropDownSearch={onDropDownSearch}
            isUploadCompleted={isUploadCompleted}
            hasSuccessfulData={hasSuccessfulData}
            isFileValid={isFileValid}
          >
            <Grid container>
              <Grid item xs={12}>
                <Typography
                  variant='body2'
                  sx={{mb: 2, color: 'text.secondary'}}
                >
                  <strong>Required Headers:</strong> Full Name, Phone, Age,
                  E-mail Address, Country, marks, MPC_4, data_source
                </Typography>
                <BasicDropZone
                  setFiles={setUploadedFiles}
                  files={uploadedFiles}
                  isInvalid={!isFileValid}
                />
                {validationError && (
                  <Alert severity='error' sx={{mt: 2}}>
                    <AlertTitle>❌ Invalid File</AlertTitle>
                    <Typography variant='body2' sx={{mb: 1}}>
                      {validationError}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{fontSize: '0.875rem', color: 'text.secondary'}}
                    >
                      Required headers: Full Name, Phone, Age, E-mail Address,
                      Country, marks, MPC_4, data_source
                    </Typography>
                  </Alert>
                )}
              </Grid>
              <MatrixForBDAPI
                allStatusCountDB={allStatusCountDB}
                doneStatusCountDB={doneStatusCountDB}
                errorStatusCountDB={errorStatusCountDB}
                errorDataDB={errorDataDB}
                allStatusCountAPI={allStatusCountAPI}
                doneStatusCountAPI={doneStatusCountAPI}
                errorStatusCountAPI={errorStatusCountAPI}
                errorDataAPI={errorDataAPI}
                messages={messages}
                fileName={fileName}
                isClicked={isClicked}
                hasSuccessfulData={hasSuccessfulData}
              />
            </Grid>
          </CAppComponentCard>
        </Grid>
      </AppGridContainer>
    </>
  );
};

AddDataUI.propTypes = {
  setUploadedFiles: PropsType.func.isRequired,
  uploadedFiles: PropsType.array.isRequired,
  functionToRun: PropsType.func.isRequired,
  handleDomainChange: PropsType.func.isRequired,
  domainSelected: PropsType.any,
  sendDataLoading: PropsType.bool.isRequired,
  fileSelected: PropsType.bool.isRequired,
  isClicked: PropsType.bool.isRequired,
  messages: PropsType.any,
  fileName: PropsType.string.isRequired,
  affiliateId: PropsType.array.isRequired,
  dominId: PropsType.array.isRequired,
  onDropDownChange: PropsType.func.isRequired,
  onDropDownSearch: PropsType.func.isRequired,
  allStatusCountDB: PropsType.number.isRequired,
  doneStatusCountDB: PropsType.number.isRequired,
  errorStatusCountDB: PropsType.number.isRequired,
  errorDataDB: PropsType.array.isRequired,
  allStatusCountAPI: PropsType.number.isRequired,
  doneStatusCountAPI: PropsType.number.isRequired,
  errorStatusCountAPI: PropsType.number.isRequired,
  errorDataAPI: PropsType.array.isRequired,
  // Add validation prop types
  validationError: PropsType.string,
  isFileValid: PropsType.bool,
  // Add upload completion prop types
  isUploadCompleted: PropsType.bool,
  hasSuccessfulData: PropsType.bool,
};

export default AddDataUI;
